import { Directive } from 'angular-ts-decorators';

import { Session } from '@shared/app/scripts/services/session';

/**
 * A directive which can be used to show or hide an element based on a user's
 * tenant type. This directive relies on the {@link sharedModule.currentSession}
 * to contain a tenant wholesale boolean.
 *
 * Note! This directive uses the same css as {@link
 * coreModule.directive:swAllowed}, and they collide. Workaround for this is to
 * put them on separate DOM elements, with the more important outside.
 *
 * # HTML Example
 * <code><pre>
 * <button sw-if-wholesale>Button that only wholesale users will see</button>
 * </pre></code>
 */
@Directive({
  selector: '[sw-if-wholesale]',
})
export class SwIfWholesaleDirective {
  constructor(
    private session: Session,
    private $element: ng.IAugmentedJQuery,
  ) {
    'ngInject';
  }

  $postLink() {
    this.session.current$.subscribe((sessionCurrent) => {
      if (sessionCurrent.wholesale) {
        this.$element.removeClass('ng-hide');
      } else {
        this.$element.addClass('ng-hide');
      }
    });
  }
}
